(() => {
  if (window.astraHeaderReady) return;
  window.astraHeaderReady = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.astra-header details[open]');
    if (open) { open.open = false; open.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.astra-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
      else if (event.target.closest('a')) details.open = false;
    });
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('.astra-header details') || !details.open) return;
    document.querySelectorAll('.astra-header details[open]').forEach(other => {
      if (other !== details) other.open = false;
    });
    if (details.matches('.astra-search')) details.querySelector('input[type="search"]')?.focus();
  }, true);
  const updateCount = async () => {
    const header = document.querySelector('[data-astra-cart-url]');
    if (!header) return;
    try {
      const response = await fetch(header.dataset.astraCartUrl + '.js');
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-astra-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    } catch {}
  };
  document.addEventListener('theme:cart::added', updateCount);
  window.addEventListener('pageshow', updateCount);
})();